import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchProductDetails } from "../../services/api";

export const fetchProductDetailsThunk = createAsyncThunk(
  "product/productDetails",
  async (pId, { rejectWithValue }) => {
    try {
      const res = await fetchProductDetails(pId);
      return res.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const productDetailsSlice = createSlice({
  name: "productDetails",
  initialState: {
    loading: false,
    error: null,
    product: null,
    success: false
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchProductDetailsThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProductDetailsThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.product = action.payload.product; 
        state.success = true;
      })
      .addCase(fetchProductDetailsThunk.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload;
      });
  }
});

export default productDetailsSlice.reducer;